/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import QS from 'query-string';
import { Auth, Project } from '@leverege/api-redux';
import { Flex, Pane } from '@leverege/ui-elements';
import { Config } from '@leverege/plugin';
import { LoginRoutes } from '@leverege/api-ui-login';
import { ValuesCache } from '@leverege/value-cache';
import { History, withMolten } from '@leverege/molten-core';
import Util from "./Util.js";
import { jsx as _jsx } from "react/jsx-runtime";
class LoginScreen extends React.Component {
  constructor(props) {
    super(props);
    this.cache = new ValuesCache();
  }
  componentDidMount() {
    const {
      location
    } = this.props;
    if (location.pathname?.startsWith('/p')) {
      localStorage.setItem('redirectUrl', `${location.pathname}${location.search}`);
    }
  }
  getLoginOpts = () => {
    const {
      oidcClients,
      api,
      userCode,
      molten
    } = this.props;
    return this.cache.calc('loginOpts', (oidcClients, api, userCode) => {
      let oc = oidcClients && Object.values(oidcClients);
      if (oc) {
        oc = Util.filterOidcClients(oc, Config.get('LoginScreen', 'oidcClientFilter'));
      }
      const providers = oc == null || oc.length === 0 ? null : oc.map(c => {
        const sParams = new URLSearchParams({
          userCode: userCode || ''
        });
        const eParams = new URLSearchParams({
          error: c.name,
          userCode: userCode || ''
        });
        const loginUrl = api.oidcLoginUrl(c, `${window.location.origin}/?${sParams.toString()}`, `${window.location.origin}/login?${eParams.toString()}`);
        return {
          name: c.name,
          icon: c.icon || `fa fa-fw fa-${c.alias}`,
          loginUrl
        };
      });

      // Including this logo option for backward compatibility
      const loginLogoSelector = molten.getConfig('logo/selectors/login');
      const loginLogoVariant = loginLogoSelector ? loginLogoSelector(window.location) : 'loginLogo';
      const loginOpts = Config.get('LoginScreen', 'loginOpts');
      const forgotPasswordOpts = Config.get('LoginScreen', 'forgotPasswordOpts');
      const requestLoginCodeOpts = Config.get('LoginScreen', 'requestLoginCodeOpts');
      const loginByCodeOpts = Config.get('LoginScreen', 'loginByCodeOpts');
      const twoFactorVerifyOpts = Config.get('LoginScreen', 'twoFactorVerifyOpts');
      const twoFactorEnrollOpts = Config.get('LoginScreen', 'twoFactorEnrollOpts');
      const resetPasswordOpts = Config.get('LoginScreen', 'resetPasswordOpts');
      const activateAccountOpts = Config.get('LoginScreen', 'activateAccountOpts');
      const requestDeviceCodeOpts = Config.get('LoginScreen', 'requestDeviceCodeOpts');
      return {
        adjustPath: History.adjustPath,
        identityProviders: providers,
        loginOpts: {
          ...loginOpts,
          variants: {
            loginLogoVariant,
            ...loginOpts?.variants
          }
        },
        forgotPasswordOpts: {
          ...forgotPasswordOpts,
          variants: {
            loginLogoVariant,
            ...forgotPasswordOpts?.variants
          }
        },
        requestLoginCodeOpts: {
          ...requestLoginCodeOpts,
          variants: {
            loginLogoVariant,
            ...requestLoginCodeOpts?.variants
          }
        },
        loginByCodeOpts: {
          ...loginByCodeOpts,
          variants: {
            loginLogoVariant,
            ...loginByCodeOpts?.variants
          }
        },
        twoFactorVerifyOpts: {
          ...twoFactorVerifyOpts,
          variants: {
            loginLogoVariant,
            ...twoFactorVerifyOpts?.variants
          }
        },
        twoFactorEnrollOpts: {
          ...twoFactorEnrollOpts,
          variants: {
            loginLogoVariant,
            ...twoFactorEnrollOpts?.variants
          }
        },
        resetPasswordOpts: {
          ...resetPasswordOpts,
          variants: {
            loginLogoVariant,
            ...resetPasswordOpts?.variants
          }
        },
        activateAccountOpts: {
          ...activateAccountOpts,
          variants: {
            loginLogoVariant,
            ...activateAccountOpts?.variants
          }
        },
        requestDeviceCodeOpts: {
          ...requestDeviceCodeOpts,
          variants: {
            loginLogoVariant,
            ...requestDeviceCodeOpts?.variants
          }
        }
      };
    }, oidcClients, api, userCode);
  };
  render() {
    return /*#__PURE__*/_jsx(Pane, {
      variant: "loginBackground",
      style: {
        width: '100%',
        height: '100%'
      },
      children: /*#__PURE__*/_jsx(Flex, {
        direction: "row",
        align: "center",
        justify: "center",
        vFill: true,
        children: /*#__PURE__*/_jsx(LoginRoutes, {
          ...this.getLoginOpts()
        })
      })
    });
  }
}
export default withMolten(connect((state, ownProps) => {
  const {
    molten
  } = ownProps;
  return {
    auth: state.auth,
    api: molten.get('api'),
    projectId: molten.get('projectId'),
    oidcClients: Project(molten.getConfig('api/projectId')).oidcClients().getOidcClients(state),
    queryParams: QS.parse(state.router.location.search),
    router: state.router,
    userCode: state.auth.deviceAccessTokenRequest?.userCode
  };
}, (dispatch, ownProps) => {
  const {
    molten
  } = ownProps;
  return {
    login: (user, pass) => {
      dispatch(Auth.login(user, pass));
    },
    loginWith2FA: (code, method, rememberMe) => {
      dispatch(Auth.loginWith2FA(code, method, rememberMe));
    },
    requestLoginCode: (user, method) => {
      dispatch(Auth.requestLoginCode(user, method));
    },
    submitLoginCode: (user, code) => {
      dispatch(Auth.loginWithCode(user, code));
    },
    logout: () => {/* dispatch( Auth.logout() ) Dont do this, causes reload and goes back to user/password */},
    reset2FAVerify: () => {
      dispatch(Auth.reset2FAVerify());
    },
    reset: email => {
      dispatch(Auth.forgotPassword(email, molten.getConfig('api/projectId'), {
        uiName: molten.getConfig('uiName')
      }));
    }
  };
})(LoginScreen));